jQuery(document).ready(function($){
    console.log('Script personalizado funcionando');

    // Agregar botones para compartir 
    $.each( $('#grid-banner-home .grid-banner .grid-banner__inner .f-column'), function(i, v){
        var $this = $(this),
            $boxButtons = '<div class="box-buttons">' + 
                            '<div class="buttons">' +
                                '<a href="javascript:void(0)" class="btn-notify"><i class="fa-solid fa-bell"></i></a>' + 
                                '<a href="javascript:void(0)" class="btn-share"><i class="fa-solid fa-share"></i></a>' + 
                            '</div>' + 
                          '</div>';

        
        // Agregar elementos a grid 
        $(this).find('.card-media').append($boxButtons);
    });

    // Mostrar botones de compartir 
    $('#grid-banner-home').on('click', '.box-buttons .btn-share', function(){
        var $this = $(this), 
            boxMedia = $this.closest('.card-media');

        // Calcular tamaño de caja 
        var wBox = boxMedia.outerWidth(),
            hBox = boxMedia.outerHeight();

        boxMedia.find('.sharethis-inline-share-buttons').toggleClass('show');
        boxMedia.find('.sharethis-inline-share-buttons').css({'left': ((wBox * 0.04) / 2) + 'px', 'top': ((50) + 40) + 'px'});
        $this.toggleClass('show');
    });

    // Función para inicializar los contadores personalizados
    function initCustomCountdowns() {
        $('.custom-countdown').each(function() {
            const $element = $(this);
            const targetDate = $element.data('date');
            
            if (targetDate) {
                startCountdown($element, targetDate);
            }
        });
    }
    
    // Función principal del contador
    function startCountdown($element, targetDateString) {
        const targetDate = new Date(targetDateString);
        
        // Verificar que la fecha es válida
        if (isNaN(targetDate.getTime())) {
            $element.html('<div class="countdown-error">Fecha inválida</div>');
            return;
        }
        
        // Función para actualizar el contador
        function updateCountdown() {
            const now = new Date().getTime();
            const distance = targetDate.getTime() - now;
            
            // Si la fecha ya pasó
            if (distance < 0) {
                $element.html('<div class="countdown-finished">¡Tiempo terminado!</div>');
                return;
            }
            
            // Calcular tiempo restante
            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);
            
            // Formatear números con ceros a la izquierda
            const formatNumber = (num) => num.toString().padStart(2, '0');
            
            // Generar HTML del contador
            const countdownHTML = `
                <div class="countdown-container">
                    <div class="countdown-item">
                        <div class="countdown-number">${formatNumber(days)}</div>
                        <div class="countdown-label">Dias</div>
                    </div>
                    <div class="countdown-separator">:</div>
                    <div class="countdown-item">
                        <div class="countdown-number">${formatNumber(hours)}</div>
                        <div class="countdown-label">Hrs</div>
                    </div>
                    <div class="countdown-separator">:</div>
                    <div class="countdown-item">
                        <div class="countdown-number">${formatNumber(minutes)}</div>
                        <div class="countdown-label">Min</div>
                    </div>
                    <div class="countdown-separator">:</div>
                    <div class="countdown-item">
                        <div class="countdown-number">${formatNumber(seconds)}</div>
                        <div class="countdown-label">Seg</div>
                    </div>
                </div>
            `;
            
            $element.html(countdownHTML);
        }
        
        // Actualizar inmediatamente
        updateCountdown();
        
        // Actualizar cada segundo
        const interval = setInterval(updateCountdown, 1000);
        
        // Guardar el intervalo en el elemento para poder limpiarlo después
        $element.data('countdown-interval', interval);
    }

    // Inicializar los contadores al cargar la página
    initCustomCountdowns();
});